import type { ChainCheckpoint, ChainVerifyResult, LedgerEntry } from '../types/contact'

const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1'

export async function fetchLedgerEntries(
  tableName: 'reports' | 'contacts',
  recordId: string,
): Promise<LedgerEntry[]> {
  const params = new URLSearchParams({ table_name: tableName, record_id: recordId })
  const res = await fetch(`${BASE}/ledger/entries?${params.toString()}`)
  if (!res.ok) throw new Error('Failed to load ledger history')
  return res.json()
}

export async function fetchChainVerify(): Promise<ChainVerifyResult> {
  const res = await fetch(`${BASE}/ledger/chain/verify`)
  if (!res.ok) throw new Error('Failed to verify ledger')
  return res.json()
}

// Chain-tip checkpoints (tail-truncation protection) — see api/bio_api/services/checkpoint.py.
// null (not thrown) on 404: "no checkpoint yet" is an expected, displayable state, not an error.
export async function fetchLatestCheckpoint(): Promise<ChainCheckpoint | null> {
  const res = await fetch(`${BASE}/ledger/checkpoints/latest`)
  if (res.status === 404) return null
  if (!res.ok) throw new Error('Failed to load latest checkpoint')
  return res.json()
}

export async function fetchCheckpoints(limit = 50): Promise<ChainCheckpoint[]> {
  const res = await fetch(`${BASE}/ledger/checkpoints?limit=${limit}`)
  if (!res.ok) throw new Error('Failed to load checkpoints')
  return res.json()
}
